import { _ as _taggedTemplateLiteralLoose } from '../../../dist/taggedTemplateLiteralLoose-7a042257.esm.js';
import styled from 'styled-components';
import { t as textSizes } from '../../../dist/typography-38bb6adc.esm.js';

var _templateObject;
var Text = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: ", "\n"])), function (_ref) {
  var size = _ref.size;
  return textSizes[size || 'BaseW1'];
}, function (_ref2) {
  var color = _ref2.color;
  return color || '';
});

export { Text };
